<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Change Meter Unit'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="ttmodal__body">

    <div>{{'What is the old SMU/Hourmeter meter reading?' | translate | async}} </div>

    <mat-form-field class="input">
      <input matInput placeholder="{{'Old SMU/Hourmeter' | translate | async}}" type="text" [(ngModel)]="oldMeterSMUReading" [formControl]="oldsmuReadingInput"
        min="preChangeMeterSMU" ngDefaultControl required>
    </mat-form-field>

    <div *ngIf="oldsmuReadingInput.errors && (oldsmuReadingInput.dirty || oldsmuReadingInput.touched)" style="margin-bottom: 20px;">
      <mat-error *ngIf="oldsmuReadingInput.errors.required">{{'Old SMU/Hourmeter Reading is required'| translate | async}}</mat-error>
      <mat-error *ngIf="oldsmuReadingInput.errors.min">{{'Old SMU/Hourmeter must be greater than previous SMU/Hourmeter'| translate | async}}</mat-error>
    </div>

    <div>{{'What is the new meter SMU/Hourmeter reading?'| translate | async}} </div>
    <mat-form-field class="input">
      <input matInput placeholder="{{'New SMU/Hourmeter' | translate | async}}" type="text" [(ngModel)]="newSMUReadingOnNewMeter" [formControl]="newsmuReadingInput"
        ngDefaultControl required>
    </mat-form-field>
    <div *ngIf="newsmuReadingInput.errors && (newsmuReadingInput.dirty || newsmuReadingInput.touched)" style="margin-bottom: 20px;">
      <mat-error *ngIf="newsmuReadingInput.errors.required">{{'New SMU/Hourmeter Reading is required'| translate | async}}</mat-error>
    </div>

    <div>{{'What is the date of the replacement? '| translate | async}}</div>
    <mat-form-field class="input">
      <input matInput [matDatepicker]="myDatepicker" placeholderout="Date of Replacement" readonly [(ngModel)]="dateReplaced"  [formControl]="ChangeMeterDateControl"  >
      <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #myDatepicker></mat-datepicker>
    </mat-form-field>

  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">{{'Cancel'| translate | async}}</button>
    <button mat-raised-button color="warn" [class.loading]="saving" (click)="changeMeterUnitClicked()"   [disabled]= "oldsmuReadingInput.errors || newsmuReadingInput.errors">
      <span class="material-icons button__icon">check</span>
      <span class="button__text">{{'Change Meter Unit'| translate | async}}</span>
    </button>
  </div>
</div>
